import VT from '@/store/types';

export default {
  [VT.AUDIT_LOGS_LIST]: (state, { data, status }) => {
    state.auditLogsList = { data, status };
  },
};
